import React, { forwardRef } from "react";
import rules from "../../rules";

const check = (role, action, data) => {
  const permissions = rules[role];
  if (!permissions) {
    return false;
  }

  const staticPermissions = permissions.static;

  if (staticPermissions && staticPermissions.includes(action)) {
    return true;
  }

  const dynamicPermissions = permissions.dynamic;

  if (dynamicPermissions) {
    const permissionCondition = dynamicPermissions[action];
    if (!permissionCondition) {
      return false;
    }

    return permissionCondition(data);
  }
  return false;
};

const Can = forwardRef(({ role, perform, data, yes, no }, ref) => {
  return <div ref={ref}>{check(role, perform, data) ? yes() : no()}</div>;
});

Can.defaultProps = {
  yes: () => null,
  no: () => null,
};

export { Can };
